<template>
  <div class="m-4">
    <div class="max-w-sm">
      <Input
        label="Username"
        @change="nameInput"
      />
    </div>

    <div class="max-w-sm mt-4">
      <Input
        label="Password"
        type="password"
        @change="nameInput"
      />
    </div>

    <div class="max-w-sm mt-4">
      <Input
        label="Website"
        placeholder="mywebsite.com"
        add-on="https://"
        @change="nameInput"
      />
    </div>

    <div class="w-48 mt-4">
      <Input
        label="Price"
        add-on="£"
        :add-on-border="false"
        tag="GBP"
        type="number"
        @change="nameInput"
      />
    </div>

    <div class="max-w-sm mt-4">
      <AboutMe
        label="About Me"
        explainer="Write a few sentences about yourself."
      />
    </div>

    <div class="max-w-sm mt-4">
      <CheckboxItem
        title="Bookings"
        description="Get notified when someone books a slot."
      />
    </div>

    <div class="max-w-sm mt-4">
      <CheckboxItem
        title="Keep me logged in"
      />
    </div>

    <div class="max-w-sm mt-4">
      <Dropdown
        label="Assign to"
        :list="assignList"
        :allow-search="true"
        :multi-select="true"
      />
    </div>
    <!--
    <div class="max-w-sm mt-64">
      <MultiDropdown
        label="Assign to"
        :allowSearch="true"
        :list="assignList"
        assignText="Contacts Assigned"
      />
    </div>  -->

    <div class="max-w-sm mt-4">
      <Email
        :required="true"
        @input="emailInput"
        @errors="setEmailErrors"
      />
    </div>

    <div class="max-w-sm mt-4">
      <PhoneNumber
        :required="true"
        @input="numberInput"
        @errors="setNumberErrors"
      />
    </div>

    <div class="max-w-sm mt-4">
      <Password
        :required="true"
        @input="passwordInput"
        @errors="setPasswordErrors"
      />
    </div>

    <div class="max-w-sm mt-4">
      <ConfirmPassword
        @input="confirmPasswordInput"
        @errors="setConfirmPasswordErrors"
      />
    </div>

    <div>
      <div
        v-for="error in emailErrors"
        :key="error"
      >
        {{ error }}
      </div>
      <div
        v-for="error in numberErrors"
        :key="error"
      >
        {{ error }}
      </div>
      <div
        v-for="error in passwordErrors"
        :key="error"
      >
        {{ error }}
      </div>
      <div
        v-for="error in confirmPasswordErrors"
        :key="error"
      >
        {{ error }}
      </div>
    </div>
  </div>
</template>

<script>
import Input from '@/app/shared/components/form/inputs/input.vue';
import AboutMe from '@/app/shared/components/form/textarea/textarea.vue';
import CheckboxItem from '@/app/shared/components/form/checkbox/checkboxItem.vue';
import Dropdown from '@/app/shared/components/form/dropdown/dropdown.vue';
import Email from '@/app/shared/components/form/fields/email.vue';
import PhoneNumber from '@/app/shared/components/form/fields/phoneNumber.vue';
import Password from '@/app/shared/components/form/fields/password.vue';
import ConfirmPassword from '@/app/shared/components/form/fields/confirmPassword.vue';

export default {
  name: 'Forms',

  components: {
    Input,
    AboutMe,
    CheckboxItem,
    Dropdown,
    Email,
    PhoneNumber,
    Password,
    ConfirmPassword,
  },

  data() {
    return {
      name: '',
      aboutMe: '',

      email: '',
      password: '',
      confirmPassword: '',
      phoneNumber: '',

      emailErrors: [],
      numberErrors: [],
      passwordErrors: [],
      confirmPasswordErrors: [],

      assignList: [
        { primaryText: 'Tim Davies', secondaryText: 'Software Developer' },
        { primaryText: 'Simon James', secondaryText: 'Graphic Designer' },
        { primaryText: 'Callum Trundle', secondaryText: 'Accountant' },
      ],
    };
  },

  computed: {

  },

  methods: {
    numberInput(input) {
      this.phoneNumber = input;
    },

    passwordInput(input) {
      this.password = input;
    },

    confirmPasswordInput(input) {
      this.confirmPassword = input;
    },

    emailInput(input) {
      this.email = input;
    },

    setEmailErrors(errors) {
      this.emailErrors = errors;
    },

    setNumberErrors(errors) {
      this.numberErrors = errors;
    },

    setPasswordErrors(errors) {
      this.passwordErrors = errors;
    },

    setConfirmPasswordErrors(errors) {
      this.confirmPasswordErrors = errors;
    },

    nameInput(name) {
      this.name = name;
    },
  },

};
</script>
